module.exports = __webpack_public_path__ + "img/剪切3.eb4e9b40.svg";